import { useCallback, useState } from 'react';

export const TUTORIAL_SESSION_KEY = 'ticketkoala-tutorial-complete';

export interface UseTutorialResult {
  isActive: boolean;
  complete: () => void;
}

export function useTutorial(): UseTutorialResult {
  const [isActive, setIsActive] = useState(() => {
    try {
      return sessionStorage.getItem(TUTORIAL_SESSION_KEY) !== '1';
    } catch {
      return true;
    }
  });

  const complete = useCallback(() => {
    try {
      sessionStorage.setItem(TUTORIAL_SESSION_KEY, '1');
    } catch {
      /* ignore */
    }
    setIsActive(false);
  }, []);

  return { isActive, complete };
}
